import React, { Component } from 'react'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'
import PropTypes from 'prop-types'
import Button from '../components/Button'
// import Dropdown from '../components/Dropdown'
import Textbox from '../components/Textbox'

import Utils from '../lib/utils'

class BookingInstructionForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      info: props.info
    }
    this.onChange       = this.onChange.bind(this)
    this.addInstruction = props.addInstruction.bind(this)
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)    

    const instructionSkus = props.skus.filter(sku => sku.product === Utils.getProductFrom('instruction').stripeProductId)
    const privateGroupSmall = instructionSkus.filter(sku => sku.attributes.type === 'private' && sku.attributes.size === 'sm')
    const privateGroupLarge = instructionSkus.filter(sku => sku.attributes.type === 'private' && sku.attributes.size === 'lg')
    const publicGroup = instructionSkus.filter(sku => sku.attributes.type === 'public')
    
    this.instructionTypeGroups = { privateGroupSmall, privateGroupLarge, publicGroup }
  }

  onChange(e) {
    const {info} = this.state
    this.setState({
      info: {
        ...info,
        [e.target.name]: e.target.value
      }
    })
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }
  
  selectSku(skuId, skuName) {
    const {info} = this.state
    info.skuId = info.skuId === skuId ? null : skuId
    info.skuName = info.skuName === skuName ? null : skuName
    this.setState({info})
  }

  selectSkiOrBoard(selection) {
    const {info} = this.state
    this.setState({
      info: {...info, skiOrBoard: selection }
    })
  }

  render() {
    const { info } = this.state
    const submitInfo = () => this.addInstruction(info)

    return (
      <div className="pb-12 md:pb-0">
        <div className="mb-4 border-b">
          <h2>
            <FormattedMessage id="booking.person.instruction.header" defaultMessage="Book instructor" />
          </h2>
          {/* <p>
            <FormattedMessage id="booking.person.instruction.desc" defaultMessage="Add personal ski instruction to your booking" />
            <Link to="/" className="underline text-harbor">
              Read more about instruction
            </Link>
          </p> */}
        </div>
        
        {/* Ski or snowboard selection block */}
        <div className="border-b pb-2 mb-4">
          <p className="text-sm mt-4 mb-0">
              <FormattedMessage id="booking.person.instruction.skiorboard" defaultMessage="Ski or snowboard" />
          </p>
          <div className="md:w-2/3 flex flex-row mb-2">
          <button
            onClick={() => { this.selectSkiOrBoard('ski') }}
            className="flex items-center mt-4 mr-12 focus:outline-none"
            type="button"
            >
            <>
              <div className="custom-radio flex rounded-full border border-grey-dark bg-white min-w-6 h-6 mr-2 items-center justify-center">
                { info.skiOrBoard === 'ski' && (
                  <div className="rounded-full bg-harbor w-3 h-3" />
                )}
              </div> 
              <div className='flex-grow text-sm'>
                <FormattedMessage id='booking.person.instruction.skiradiotext' defaultMessage="Ski" />
                &nbsp;
                
              </div>                   
              
            </>
          </button>
          <button
            onClick={() => { this.selectSkiOrBoard('board') }}
            className="flex items-center mt-4 focus:outline-none"
            type="button"
            >
            <>
              <div className="custom-radio flex rounded-full border border-grey-dark bg-white min-w-6 h-6 mr-2 items-center justify-center">
                { info.skiOrBoard === 'board' && (
                  <div className="rounded-full bg-harbor w-3 h-3" />
                )}
              </div> 
              <div className='flex-grow text-sm'>
                <FormattedMessage id='booking.person.instruction.snowboardradiotext' defaultMessage="Snowboard" />
                &nbsp;
                
              </div>                   
              
            </>
          </button>
          </div>
         
        </div>
        
        {/* Age and experience block */}
        <div className="border-b pb-2">
          <div className="md:w-2/3">
            <label className="flex items-center">
              <div className="w-1/2">
                <FormattedMessage id="booking.person.instruction.age" defaultMessage="Your age" />
              </div>
              <Textbox
                htmlId="age"
                htmlName="age"
                type="number"
                onChange={this.onChange}
                className="w-24"
                value={info.age}
              />
              &nbsp;&nbsp;
              <span className="text-sm">
                <FormattedMessage id="booking.person.instruction.years" defaultMessage="years old" />
              </span>
            </label>

            <label className="flex items-center mt-4">
              <div className="w-1/2">
                <FormattedMessage id="booking.person.instruction.experience" defaultMessage="Your experience" />
              </div>
              <Textbox
                htmlId="experience"
                htmlName="experience"
                type="number"
                onChange={this.onChange}
                className="w-24"
                value={info.experience}
              />
              &nbsp;&nbsp;
              <span className="text-sm">
                <FormattedMessage id="booking.person.instruction.weeksSkiing" defaultMessage="weeks skiing" />
              </span>
            </label>          
          </div>
          <p className="text-sm mt-4">
            <FormattedMessage id="booking.person.instruction.help" defaultMessage="We use your age and experience to find you a suitable class or instructor" />
          </p>
        </div>
        <h3 className="mt-8">
          <FormattedMessage id="booking.person.instruction.header2" defaultMessage="I would like" />
        </h3>
        <div className="md:flex">
          { console.log('Instructions groups: ', this.instructionTypeGroups)  }
          {Object.keys(this.instructionTypeGroups).filter(key => key !== 'publicGroup').map(key => (  
            <div className="flex-1 pb-2 mt-4" key={this.getKey()}>
              <h4>
                <FormattedMessage id={`booking.person.instruction.${key}`} />
              </h4>
              <div className="text-xs md:mr-8 md:h-8">
                <FormattedMessage id={`booking.person.instruction.${key}.desc`} />
              </div>
              {this.instructionTypeGroups[key].map(sku => {
                const skuName = `${key}${sku.attributes.hours}`
                return (
                  <button
                    onClick={() => { this.selectSku(sku.id, skuName) }}
                    className="flex items-center mt-4"
                    type="button"
                    key={this.getKey()}
                  >
                    <>
                      <div className="custom-radio flex rounded-full border border-grey-dark bg-white min-w-6 h-6 mr-2 items-center justify-center">
                        { info.skuId === sku.id && (
                          <div className="rounded-full bg-harbor w-3 h-3" />
                        )}
                      </div> 
                      <div className={`flex-grow text-sm ${info.skuId === sku.id && 'font-bold'}`}>
                        {sku.attributes.hours}
                        &nbsp;
                        <FormattedMessage id={`booking.person.instruction.${sku.attributes.hours === '1' ? 'hour' : 'hours'}`} defaultMessage="hours" />
                        &nbsp;
                        (
                        <FormattedNumber 
                          value={sku.price / 100}
                          minimumFractionDigits={2}
                        />
                        &nbsp;kr.)
                      </div>                   
                      
                    </>
                  </button>
                )
              })}
            </div>
          ))}

           {/* Instructions note starts here */}
           <div className="flex-1 pb-2 mt-12 text-xs text-xs md:mr-8 md:h-8">
          <FormattedMessage
              id="booking.person.instruction.contactnote"
              defaultMessage="If you're booking instruction, within the next 24 hours, make sure to contact us on phone 71741904 or email skischool@copenhill.dk in order to make sure we are able to find a vacant instructor."
            />
          </div>
          
        </div>

        <Button
          onClick={submitInfo}
          className="mt-8"
        >
          <FormattedMessage id="booking.person.instruction.submit" defaultMessage="Update booking" />
        </Button>
      </div>
    )
  }
}


BookingInstructionForm.propTypes = {
  info: PropTypes.shape({ info: PropTypes.object }).isRequired,
  addInstruction: PropTypes.func.isRequired,
  skus: PropTypes.instanceOf(Array).isRequired
}

BookingInstructionForm.defaultProps = {}

export default injectIntl(BookingInstructionForm)